// extracted by mini-css-extract-plugin
export default {"container":"styles_container__BWOLm","chevron":"styles_chevron__1V3lr","move-chevron":"styles_move-chevron__M4P8o"};